import { Inject, Injectable, OnInit } from '@angular/core';
import {Component} from '@angular/core';
import { MatSnackBar, MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';  


@Injectable({
	providedIn: 'root'
})
export class SnackbarService {

	constructor(private $matSnactBar:MatSnackBar) { }


	error(message: string, subMessage:string="", option:any={}) { 
		this.showMatComponent("snackbar-error", message, subMessage, option);
	}

	success(message: string, subMessage:string="", option:any={}) { 
		this.showMatComponent("snackbar-success", message, subMessage, option);
	}

	warning(message: string, subMessage:string="", option:any={}) {
		this.showMatComponent("snackbar-warning", message, subMessage, option);
	}

	info(message: string, subMessage:string="", option:any={}){
		this.showMatComponent("snackbar-info", message, subMessage, option);
	}

	show(message: string, subMessage:string="", option:any={}){
		this.showMatComponent("", message, subMessage, option);
	}

	showMatMessage(messageType: string, message: string="", option:any = {}) {
		let defaultOpt:any = {
			horizontalPosition: "center",
			verticalPosition: "top",
			duration: 3000,
			panelClass: messageType,
		};

		Object.assign(defaultOpt, option);
		this.$matSnactBar.open(message, "", defaultOpt);
	}

	showMatComponent(messageType:string, message:string, submessage:string="", option:any={}){

		let defaultOpt:any = {
			horizontalPosition: "center",
			verticalPosition: "top",
			duration: 3000,
			panelClass: messageType,
			data: {
				message: message,
				submessage: submessage,
				type: messageType
			}
		};
		Object.assign(defaultOpt, option);

		this.$matSnactBar.openFromComponent(CustomSnackbarContentComponent, defaultOpt);
	}


	
}


@Component({
	selector: 'snackbar-custom-message',
	template: `
	<div class="panel-wrapper" [ngClass]="textClass">
		<div class="msg-content-wrapper"> 
			<mat-icon class="mat-msg-ico" *ngIf="icon">{{icon}}</mat-icon> 
			<div class="msg-content">
				<label>{{message}}</label>
				<label class="submsg" *ngIf="subMessage != ''">{{subMessage}}</label> 
			</div>
		</div>
		<button mat-icon-button (click)="dismiss()">
			<mat-icon>close</mat-icon>
		</button>
	</div>`,
	styles: [`
		.panel-wrapper{
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
		}
		.msg-content-wrapper{
			display: flex;  
			padding-top:.5rem;
		}
		.msg-content{
			display: flex;
			flex-direction: column;
		} 
		.mat-msg-ico{
			margin-right: 10px;
		}
		.msg-white{
			color: #fff;
		}
		.submsg{
			font-size: .875em;
		}
		.msg-white .submsg{
			color: #e4e4e4;
		}
		.msg-dark{
			color: #333;
		} 
		.msg-dark .submsg{
			color: #888;
		}
	`],
  })
export class CustomSnackbarContentComponent implements OnInit{

	icon:string = "";
	message:string = "";
	subMessage:string = "";
	textClass:string = "msg-white"; 
	iconMapping:any = {
		"snackbar-error": "block",
		"snackbar-success": "check",
		"snackbar-warning": "warning_amber",
		"snackbar-info": "info",
	};

	constructor(@Inject(MAT_SNACK_BAR_DATA) private data: any,
	private _snackRef:MatSnackBarRef<any>){
	}

	ngOnInit(){ 
		this.icon = this.data.type && this.iconMapping[this.data.type] ? this.iconMapping[this.data.type] : ""; 
		this.message = this.data.message;
		this.subMessage = this.data.submessage; 
		if(this.data.type == "snackbar-warning"){
			this.textClass = "msg-dark";
		}
	}
	dismiss(){
		this._snackRef.dismiss();
	}
}